import { styled as o, css as s } from "styled-components";
import { MediaQuery as i } from "../../../styles/variables.js";
import { Avatar as c } from "../../../components/Avatar/index.js";
import { Icon as n } from "../../../components/Icon/index.js";
import { Colors as e } from "../../../styles/colors/index.js";
import { Body as g, H2Heavy as m, Small as b, SmallHeavy as x, CaptionHeavy as f, Caption as t, BodyHeavy as l } from "../../../styles/typography/index.js";
import { skeletonFadeAnimation as u } from "../../../styles/animation.js";
import { Button as d } from "../../../components/Button/index.js";
import { Theme as r, DarkThemeQuery as h, DarkNinjaThemeQuery as $ } from "../../../styles/themes/index.js";
import { Nickname as y } from "../../../components/Nickname/index.js";
const N = o.div`
  background: rgb(${r.colors.Juliet});
  padding-bottom: 24px;

  @media ${i.SCREEN_MD_UP} {
    border: 1px solid rgb(${r.colors.Golf});
    border-radius: 16px;
  }
`, S = o.div`
  background: linear-gradient(
    360deg,
    rgb(${r.colors.Juliet}) 0%,
    rgb(${r.colors.Zulu}) 100%
  );
  min-height: 72px;
  display: flex;
  color: rgb(${e.Graphite});
  padding: 0 12px;

  @media ${i.SCREEN_MD_UP} {
    min-height: 125px;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
  }

  ${g}

  i {
    @media ${i.SCREEN_MD_UP} {
      display: none;
    }
    display: block;
    margin-top: 16px;
    font-size: 24px;
  }
`, G = o.div`
  padding: 0 24px;
`, M = o.div`
  position: relative;
  padding: 0 24px;
`, B = o.div`
  display: flex;
  margin-top: -16px;

  @media ${i.SCREEN_MD_UP} {
    margin-top: -49px;
  }
`, R = o.div`
  display: flex;
  position: relative;
  border-radius: 50%;
`, U = o(n)`
  position: absolute;
  font-size: 24px;
  color: rgb(${e.Gray});
  background: rgb(${r.colors.Juliet});
  border: 1px solid rgb(${e.Silver});
  border-radius: 50%;
  right: -6px;
  top: 6px;
`, z = o(c)`
  border-radius: 50%;

  picture,
  img {
    border: none;
  }
`, F = o.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-left: 4px;

  @media ${i.SCREEN_MD_UP} {
    max-width: 100%;
  }
`, J = o.h1`
  ${m}
  color: rgb(${r.colors.Alpha});
  display: contents;
`, T = o(y)`
  display: contents;
  align-items: center;

  span {
    overflow: hidden;
    position: relative;
    padding-right: 12px;
    max-width: 312px;

    &:after {
      content: '';
      display: block;
      width: 20px;
      height: 100%;
      position: absolute;
      right: 0;
      bottom: 0;
      background: linear-gradient(
        to right,
        rgba(${r.colors.Juliet}, 0),
        rgba(${r.colors.Juliet}, 100%)
      );
    }
  }
`, I = o.button`
  color: rgb(${e.Gray});
  background: transparent;
  margin-left: 4px;
  display: flex;
  align-items: center;
  i {
    font-size: 24px;
  }
`, Q = o.p`
  color: rgb(${e.Gray});
  margin-top: 4px;
  display: flex;
  align-items: center;
  white-space: nowrap;

  ${b}

  i {
    font-size: 24px;
  }
`, W = o.div`
  display: flex;
`, j = o(n)`
  color: rgb(${r.colors.Brand});
  font-size: 24px;
  margin-right: 4px;
`, L = o.span`
  background-color: rgb(${e.Sand});
  display: flex;
  align-items: center;
  width: fit-content;
  white-space: nowrap;
  border-radius: 4px;
  padding-right: 8px;
  margin-left: 12px;

  ${h}, ${$} {
    background-color: rgb(${e.Graphite});
  }

  ${x}
`, Z = o.button`
  background-color: rgb(${r.colors.Papa});
  margin-top: 8px;
  display: flex;
  align-items: center;
  width: fit-content;
  white-space: nowrap;
  border-radius: 12px;
  padding: 8px 16px 8px 8px;

  ${f}

  :last-child {
    font-size: 24px;
    margin-left: 4px;
  }
`, q = o.div`
  margin-top: 8px;
  display: flex;
  align-items: center;
  color: rgb(${e.Gray});
  padding: 4px 0;

  ${t}

  b {
    color: rgb(${r.colors.Alpha});
  }
`, K = o.div`
  display: flex;
  align-items: center;
  color: rgb(${e.Gray});
  padding: 4px 0;

  ${t}

  b {
    color: rgb(${r.colors.Alpha});
  }
`, O = o.div`
  display: flex;
  align-items: center;
  color: rgb(${e.Gray});
  padding: 4px 0;

  ${t}

  b {
    color: rgb(${r.colors.Alpha});
  }
`, V = o.div`
  display: flex;
  align-items: center;
  padding: 4px 0;

  b {
    color: rgb(${r.colors.Alpha});
  }
`, a = s`
  ${t}
  color: rgb(${e.Gray});
  background: transparent;
`, X = o.button`
  ${a}
`, Y = o.button`
  ${a}
  margin-right: 8px;
`, oo = o.button`
  ${a}
  padding-left: 8px;
  display: flex;
  align-items: center;
  position: relative;
  &:before {
    content: '';
    position: absolute;
    left: 0;
    width: 1px;
    height: 100%;
    background: rgb(${r.colors.Romeu});
  }
`, ro = o.div`
  width: 100%;
  height: 370px;
  border-radius: 8px;

  @media ${i.SCREEN_MD_UP} {
    width: 375px;
  }

  ${({ $animate: p }) => u({ animate: p })}
`, eo = o.div`
  width: 100%;
  margin-top: 16px;
  padding: 0 24px;

  @media ${i.SCREEN_MD_UP} {
    padding: 0 16px;
  }
`, io = o(d)`
  ${l}
  width: 100%;
  height: 40px;
`, to = o(d).attrs({
  light: !0
})`
  ${l}
  width: 100%;
  height: 40px;
  background: rgb(${r.colors.Juliet});
  border: 1px solid rgb(${r.colors.Golf});

  i {
    font-size: 24px;
    margin-right: 4px;
  }

  &:hover:not(:disabled) {
    background: rgb(${r.colors.India});
    color: unset;
  }
`;
export {
  U as EditAvatarIcon,
  eo as FollowActionButtonContainer,
  io as FollowButton,
  j as IconDefault,
  Z as MyDataButton,
  T as NicknameEnhanced,
  J as NicknameWrapper,
  z as ProfileAvatar,
  M as ProfileAvatarContainer,
  B as ProfileAvatarContent,
  R as ProfileAvatarWrapper,
  X as ProfileDealsButton,
  N as ProfileHeaderContainer,
  G as ProfileHeaderContent,
  q as ProfileHeaderDeals,
  I as ProfileHeaderEditNicknameButton,
  V as ProfileHeaderFollow,
  Y as ProfileHeaderFollowers,
  oo as ProfileHeaderFollowing,
  S as ProfileHeaderHead,
  Q as ProfileHeaderMemberTime,
  F as ProfileHeaderNickname,
  ro as ProfileHeaderSkeleton,
  K as ProfileHeaderTemperature,
  O as ProfileHeaderTotalReactions,
  L as ProfileHeaderUserLabel,
  to as UnfollowButton,
  W as WrapperMember
};
